import { en } from './locales_en';
import { fr } from './locales_fr';

// Add your locales here
const locales = {
  en,
  fr,
};

export default locales;
